export default __webpack_public_path__ + "static/media/edit.fb9ba356.svg";